import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { IconButton } from "@mui/material";
import React from "react";
import { useFormikContext } from "formik";
import { useAppSelector } from "../../../Store";
import { allMessagesStore } from "../../../Store/Slices/socket/AllMessagesSlice";

interface Props {
  children?: React.ReactNode;
  [otherProps: string]: any;
}

const isFilledValue = (value: any): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim().length > 0;
  if (typeof value === "number") return Number.isFinite(value);
  if (typeof value === "boolean") return false;
  if (value instanceof Date) return !Number.isNaN(value.getTime());
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "object") return Object.keys(value).length > 0;
  return true;
};

const AppSendSubmitButton: React.FC<Props> = ({ ...otherProps }) => {
  const { typingStatus } = useAppSelector(allMessagesStore);

  const formik = useFormikContext<any>();
  const hasContent = React.useMemo(() => {
    const values = formik.values;
    if (!values) return true;
    return Object.values(values).some(isFilledValue);
  }, [formik.values]);

  return (
    <div className={`inputActionBox${hasContent ? "" : " isEmpty"}`}>
      <IconButton
        type="submit"
        {...otherProps}
        disabled={!typingStatus ? false : true}
      >
          <SendRoundedIcon/>
      </IconButton>
    </div>
  );
};

export default AppSendSubmitButton;
